var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoBackHomeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 686.38 136.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-go-back-home {\n        fill: #36c;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Active_Click_",
    "data-name": "Active (Click)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-go-back-home",
    d: "M685.3,60.68c3.35-16.6-1.5-38.67-15.97-48.48,0,0,0,0,0,.01-2.29-1.41-4.89-2.71-7.51-3.7.03,0,.07.01.1.02-.44-.16-.9-.34-1.35-.49,0,0,.02,0,.03.01,0,0-.02,0-.03,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0-.08-.03-.15-.05-.24-.08h0s0,0,0,0h0s0,0,0,0h0s-.02,0-.03,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-2.17-.72-4.32-1.33-6.55-1.93.34.09.68.17,1.02.26-.07-.02-.14-.04-.21-.06.07.02.14.04.21.05-.17-.04-.34-.09-.51-.13.17.04.34.09.51.13-.23-.06-.45-.12-.67-.17.23.06.45.12.67.17-12.85-3.24-26.46-1.98-39.61-2.87.07,0,.14,0,.22,0C424.39,1.45,232.57-4.16,41.99,5.47c0,0,.02,0,.02-.01-4.63.88-9.22,1.75-13.73,3.04.02,0,.03,0,.05,0-4.82,1.6-10.65,2.55-14.92,5.76,0,0,0,0,0,0-2.29,2.2-4.51,4.41-6.55,6.8.16-.2.37-.39.51-.59-9.95,11.91-10.84,84.51,3.59,93.61,0,0,0,0,0,0,.36.35.77.7,1.15,1.05-.01,0-.03,0-.04,0,28.38,17.76,65.19,13.26,97.53,14.34,103,1.19,204.44-.56,308.21.16,77.43-7.34,183.6,24.5,251.34-7.12-.01.03,6.81-5.19,6.8-5.16,1.76-5.16,5-9.86,6.44-15.12h0s.02-.05.03-.08c0,0,0,.01,0,.02,0,0,.01-.02.01-.03,0,0,0,.01,0,.01,4.28-13.5,4.82-27.63,2.87-41.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackHomeBg);
export default __webpack_public_path__ + "static/media/go-back-home-bg.f695bb3cea83bb17fa34bb98f943ae63.svg";
export { ForwardRef as ReactComponent };